// ─────────────────────────────────────────────
//  App.jsx — root component
//
//  VIEWS (public marketing site):
//    splash     → jiffyreview.com homepage
//    how        → How it works
//    pricing    → Pricing page
//    onboarding → 4-step merchant signup
//
//  VIEWS (merchant dashboard):
//    dashboard  → logged-in merchant area
//    customer   → customer review flow (QR scan)
// ─────────────────────────────────────────────
import { useState } from "react";

// Public pages
import Splash      from "./pages/Splash";
import HowItWorks  from "./pages/HowItWorks";
import Pricing     from "./pages/Pricing";
import Onboarding  from "./pages/Onboarding";

// Dashboard
import Sidebar        from "./components/Sidebar";
import Overview       from "./pages/Overview";
import Reviews        from "./pages/Reviews";
import QRPrint        from "./pages/QRPrint";
import Analytics      from "./pages/Analytics";
import Settings       from "./pages/Settings";
import CustomerReview from "./pages/CustomerReview";

import { DEMO_BUSINESS } from "./lib/data";

export default function App() {
  const [view, setView] = useState("splash");
  const [nav,  setNav]  = useState("overview");
  const business = DEMO_BUSINESS;

  if (view === "splash")     return <Splash      goHow={() => setView("how")} goPricing={() => setView("pricing")} goOnboard={() => setView("onboarding")} />;
  if (view === "how")        return <HowItWorks  goHome={() => setView("splash")} goPricing={() => setView("pricing")} goOnboard={() => setView("onboarding")} />;
  if (view === "pricing")    return <Pricing     goHome={() => setView("splash")} goHow={() => setView("how")} goOnboard={() => setView("onboarding")} />;
  if (view === "onboarding") return <Onboarding  goDashboard={() => { setView("dashboard"); setNav("overview"); }} />;
  if (view === "customer")   return <CustomerReview business={business} onBack={() => setView("dashboard")} />;

  const PAGE = {
    overview:  <Overview  business={business} setNav={setNav} onPreviewCustomer={() => setView("customer")} />,
    reviews:   <Reviews   />,
    qr:        <QRPrint   business={business} />,
    analytics: <Analytics />,
    settings:  <Settings  />,
  };

  return (
    <div style={{ minHeight:"100vh", background:"#0a0a0f", color:"#f0ede8", fontFamily:"'Plus Jakarta Sans', sans-serif", display:"grid", gridTemplateColumns:"220px 1fr" }}>
      <link href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800;900&display=swap" rel="stylesheet" />
      <Sidebar nav={nav} setNav={setNav} business={business} />
      <div style={{ padding:"32px 36px", overflowY:"auto" }}>
        {PAGE[nav] ?? PAGE.overview}
      </div>
    </div>
  );
}
